import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../../../config';

export default function ResetPassword() {
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [passwordAgain, setPasswordAgain] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    console.log('state: ', location.state);

    const handleLoginSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${config.API_BASE_URL_V1}forgot-password/reset`, {
                code: parseInt(location.state?.code),
                email: location.state?.email,
                password: password,
                password_confirmation: passwordAgain,
            });

            if (response.data.code === 200) {
                try {
                    const loginResponse = await axios.post(`${config.API_BASE_URL_V1}auth/login`, {
                        agency_code: location.state?.agency_code,
                        email: location.state?.email,
                        password: password,
                    });

                    if (loginResponse.status === 200) {
                        const userData = {
                            token: loginResponse.data.data.token,
                            expires_at: loginResponse.data.data.expires_at,
                            user: {
                                id: loginResponse.data.data.user.agencyId,
                                email: loginResponse.data.data.user.email,
                                name: loginResponse.data.data.user.name,
                                surname: loginResponse.data.data.user.surname,
                                username: loginResponse.data.data.user.username,
                                profile_photo: loginResponse.data.data.user.profile_photo,
                            },
                        };

                        const userCart = {
                            username: userData.user.username,
                            data: []
                        };
                        localStorage.setItem('user_data', JSON.stringify(userData));
                        localStorage.setItem('cart', JSON.stringify(userCart));
                        navigate(`/`);
                    }
                } catch (loginError) {
                    console.error('Login failed:', loginError.response?.data || loginError.message);
                    setError('Giriş işlemi başarısız oldu. Lütfen bilgilerinizi kontrol edin.');
                }
            }
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-wrapper authentication-wrapper">
            <div className="auth-bg-overlay">
                <div className="auth-container">
                    <div className="auth-content">
                        <div className="auth-card">
                            {/* Left Side - Form */}
                            <div className="auth-form-side">
                                <div className="logo-container">
                                    <img src="/assets/logo-1.png" className="floating-logo" alt="logo-img"/>
                                </div>
                                <div className="auth-form-header">
                                    <h4>Reset Password</h4>
                                    <p>Create your new password</p>
                                </div>

                                <form onSubmit={handleLoginSubmit} className="auth-form">
                                    <div className="form-group">
                                        <div className="input-icon">
                                            <span className="input-icon-addon">
                                                <i className="isax isax-lock"></i>
                                            </span>
                                            <input 
                                                type="password" 
                                                required 
                                                className="form-control form-control-lg" 
                                                value={password} 
                                                onChange={(e) => setPassword(e.target.value)} 
                                                placeholder="New password" 
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="input-icon">
                                            <span className="input-icon-addon">
                                                <i className="isax isax-lock"></i>
                                            </span>
                                            <input 
                                                type="password" 
                                                required 
                                                className="form-control form-control-lg" 
                                                value={passwordAgain} 
                                                onChange={(e) => setPasswordAgain(e.target.value)} 
                                                placeholder="Confirm new password" 
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <button 
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary btn-lg btn-block"
                                        >
                                            {loading ? 'Resetting...' : 'Reset Password'}
                                        </button>
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger">
                                            {error}
                                        </div>
                                    )}
                                </form>
                            </div>

                            {/* Right Side - Welcome Content */}
                            <div className="auth-welcome-side">
                                <div className="welcome-content">
                                    <div className="welcome-card main-card">
                                        <h2>Create New Password</h2>
                                        <p>Secure Your Account</p>
                                    </div>
                                    <div className="feature-list">
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-password"></i>
                                            </div>
                                            <p>Strong Password Required</p>
                                        </div>
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-shield"></i>
                                            </div>
                                            <p>Enhanced Security</p>
                                        </div>
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-login"></i>
                                            </div>
                                            <p>Instant Account Access</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="copyright-footer">
                <p>Copyright &copy; {new Date().getFullYear()}. All Rights Reserved, 
                    <a href="https://cornleth.com">Cornleth</a>
                </p>
            </div>

            {/* Add the same styles as ForgotPassword.jsx */}
            <style>{`
                // ... copy all styles from ForgotPassword.jsx ...
            `}</style>
        </div>
    );
}
